/**
 * @module cercaliagl/view/VAddress
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import $ from 'jquery';
import BaseView from './BaseView';
import { i18n } from '../dictionary';
/**
 * @typedef {Object} VAddressData
 * @property {string|undefined} postalcode
 * @property {string|undefined} municipality
 * @property {string|undefined} locality
 * @property {string|undefined} region
 * @property {string|undefined} subregion
 * @property {string|undefined} country
 * @property {string|undefined} txtCoord
 * @property {string|undefined} height
 * @property {string|undefined} mail
 * @property {string|undefined} tel
 * @property {string|undefined} web
 * @property {string|undefined} txtDirection
 * @property {string|undefined} txtCityPostalcode
 * @property {string|undefined} txtStreet
 * @property {string|undefined} kmh
 */
var State = {
    SUMMARY: 'summary',
    DETAILED: 'detailed',
};
/**
 * @enum {string}
 */
export var EventType = {
    DIRECTION_TO: 'direction_to',
    SAVE_GEOMETRY: 'save_geometry',
    CLOSED: 'closed',
};
/**
 * @classdesc
 */
var VAddress = /** @class */ (function (_super) {
    __extends(VAddress, _super);
    /**
     * @constructor
     */
    function VAddress() {
        var _this = this;
        var jqElement = $("<div class=\"v-address mdc-elevation--z4\">\n        <div class=\"data\">\n          <div class=\"summary\">\n            <div class=\"content\"></div>\n          </div>\n          <div class=\"detailed\">\n            <div class=\"header\">\n              <span>".concat(i18n('detailed'), "</span>\n            </div>\n            <div class=\"content\"></div>\n          </div>\n        </div>\n        <div class=\"actions\">\n          <button type=\"button\" class=\"mdc-icon-button info\">\n            <span class=\"mdc-icon-button__icon icon-info\"></span>\n          </button>\n          <button type=\"button\" class=\"mdc-icon-button routing\">\n            <span class=\"mdc-icon-button__icon icon-routing\"></span>\n          </button>\n          <button type=\"button\" class=\"mdc-icon-button save\">\n            <span class=\"mdc-icon-button__icon icon-save\"></span>\n          </button>\n          <button type=\"button\" class=\"mdc-button ok\"><span class=\"mdc-button__ripple\"></span>OK</button>\n        </div>\n       </div>"));
        _this = _super.call(this, jqElement) || this;
        /**
         * @private
         */
        _this.currentState_ = State.SUMMARY;
        /**
         * @private
         * @type {import('../servers').GeEntity}
         */
        _this.ge_ = null;
        /**
         * @private
         * @type {VAddressData}
         */
        _this.data_ = null;
        _this.initialize_();
        return _this;
    }
    /**
     * @private
     */
    VAddress.prototype.initialize_ = function () {
        var _this = this;
        this.jqElement_.find('button.info').click(function () { return _this.toggle_(); });
        this.jqElement_.find('button.routing').click(function () { return _this.emit(EventType.DIRECTION_TO, _this.ge_); });
        this.jqElement_.find('button.save').click(function () { return _this.emit(EventType.SAVE_GEOMETRY, {}); });
        this.jqElement_.find('button.ok').click(function () {
            _this.hide(true);
            _this.emit(EventType.CLOSED);
        });
    };
    /**
     * Reset.
     */
    VAddress.prototype.reset = function () {
        this.currentState_ = State.SUMMARY;
        this.jqElement_.find('.detailed').hide();
        this.jqElement_.find('.summary').show();
        this.ge_ = null;
        this.detailed_ = false;
        this.data_ = null;
    };
    /**
     * @private
     */
    VAddress.prototype.toggle_ = function () {
        var jqDetailedDiv = this.jqElement_.find('.detailed');
        var jqSummaryDiv = this.jqElement_.find('.summary');
        if (this.currentState_ === State.SUMMARY) {
            jqSummaryDiv.hide();
            jqDetailedDiv.show();
            this.currentState_ = State.DETAILED;
        }
        else if (this.currentState_ === State.DETAILED) {
            jqDetailedDiv.hide();
            jqSummaryDiv.show();
            this.currentState_ = State.SUMMARY;
        }
    };
    /**
     * @param {import('../servers').GeEntity} ge GeEntity.
     * @param {string} type Ge Type. `adr`, `st` or `adr`.
     */
    VAddress.prototype.setGeoEntity = function (ge, type) {
        var _a;
        var coord = ge.coord;
        var postalcode = ge.type === 'pc' ? ge.name.value : (ge.postalcode ? ge.postalcode.id : null);
        var municipality = ge.municipality ? ge.municipality.value : null;
        var locality = ge.city ? ge.city.value : null;
        var locationSelected = ge.name ? ge.name.value : null;
        var kmh = ge.kmh && ge.kmh !== '0' ? ge.kmh : null;
        var pc2 = ge.pc2 ? ge.pc2 : null;
        var data = {
            postalcode: postalcode,
            municipality: municipality,
            locality: locality,
            region: ge.region ? ge.region.value : null,
            subregion: ge.subregion ? ge.subregion.value : null,
            country: ge.country ? ge.country.value : null,
            txtCoord: "".concat(coord.y, ", ").concat(coord.x),
            height: ge.height ? ge.height : null,
            mail: null,
            tel: null,
            web: null,
            kmh: kmh,
            pc2: pc2,
        };
        var cityPostalCode = (postalcode ? "".concat(postalcode, " ") : '') + (locality || municipality || (locationSelected || ''));
        if (type === 'ct') {
            data.txtStreet = null;
            data.txtDirection = cityPostalCode;
            data.txtCityPostalcode = null;
        }
        else if (type === 'pc' || type === 'pc2') {
            data.txtDirection = "".concat(cityPostalCode.trim(), ", ").concat(data.country);
            data.txtCityPostalcode = null;
            data.txtStreet = null;
        }
        else {
            var prefix = ge.prefix ? "".concat(ge.prefix, " ") : '';
            var article = ge.article ? ge.article + (ge.article.slice(-1) === "'" ? '' : ' ') : '';
            var km = ge.km ? ge.km.value : null;
            var street = ge.frc ? ge.name + (km ? ", Km ".concat(km) : '') : prefix + article + (((_a = ge.sname) === null || _a === void 0 ? void 0 : _a.value) ? ge.sname.value : ge.sname);
            var housenumber = ge.housenumber ? ge.housenumber.value : null;
            var intersectionStreet = ge.intersection && parseInt(ge.intersection.dist, 10) <= 25 ? ge.intersection.name : null;
            data.txtDirection = street + (housenumber ? ", ".concat(housenumber) : '') + (intersectionStreet ? " / ".concat(intersectionStreet) : '');
            data.txtCityPostalcode = cityPostalCode;
            data.txtStreet = data.txtDirection;
        }
        this.data_ = /** @type {VAddressData} */ (data);
        this.ge_ = ge;
        this.render_();
    };
    /**
     * @param {import('../servers').GeEntity} ge GeEntity.
     */
    VAddress.prototype.setPoiEntity = function (ge) {
        var coord = ge.coord;
        var postalcode = ge.postalcode ? ge.postalcode.id : null;
        var municipality = ge.municipality ? ge.municipality.value : null;
        this.data_ = {
            postalcode: postalcode,
            locality: null,
            municipality: municipality,
            region: ge.region ? ge.region.value : null,
            subregion: ge.subregion ? ge.subregion.value : null,
            country: ge.country.value,
            tel: ge.poi_data && ge.poi_data.tel ? ge.poi_data.tel : null,
            web: ge.poi_data && ge.poi_data.web ? (ge.poi_data.web.startsWith('http') ? ge.poi_data.web : "http://".concat(ge.poi_data.web)) : null,
            mail: ge.poi_data && ge.poi_data.mail ? ge.poi_data.mail : null,
            txtStreet: null,
            txtDirection: ge.name.value,
            txtCityPostalcode: (postalcode ? "".concat(postalcode, ", ") : '') + (municipality || ''),
            txtCoord: "".concat(coord.x, ", ").concat(coord.y),
        };
        this.ge_ = ge;
        this.render_();
    };
    /**
     * @private
     */
    VAddress.prototype.render_ = function () {
        this.renderSummary_();
        this.renderDetailed_();
    };
    /**
     * @private
     */
    VAddress.prototype.renderSummary_ = function () {
        var html = "".concat(this.data_.txtDirection && this.data_.txtDirection !== 'undefined' ? "<span class=\"direction\">".concat(this.data_.txtDirection, "</span>") : '', "\n    ").concat(this.data_.pc2 ? "<span class=\"direction\">".concat(this.data_.pc2, "</span>") : '', "\n     ").concat(this.data_.txtCityPostalcode ? "<span class=\"cp-city\">".concat(this.data_.txtCityPostalcode, "</span>") : '', "\n     ").concat(this.data_.kmh ? "<div class=\"kmh-container\"><span class=\"kmh\">".concat(this.data_.kmh, "</span></div>") : '', "\n     ").concat(this.data_.tel ? "<span class=\"cp-city\">Tel: ".concat(this.data_.tel, "</span>") : '', "\n     ").concat(this.data_.mail ? "<span class=\"cp-city\">E-mail: <a href$=\"mailto:".concat(this.data_.mail, "\">").concat(this.data_.mail, "</a></span>") : '', "\n     ").concat(this.data_.web ? "<span class=\"cp-city\">Web: <a target=\"_blank\" href$=\"".concat(this.data_.web, "\">").concat(this.data_.web, "</a></span>") : '', "\n     <div class=\"coord-altitude\">\n       <span class=\"coord\">").concat(this.data_.txtCoord, "</span>\n       ").concat(this.data_.height ? "<span class=\"height\">(".concat(this.data_.height, "m)</span>") : '', "\n     </div>");
        this.jqElement_.find('.summary .content').html(html);
    };
    /**
     * @private
     */
    VAddress.prototype.renderDetailed_ = function () {
        var _a;
        var html = "".concat(this.data_.txtStreet && this.data_.txtStreet !== 'undefined' ? "<span><b>".concat(i18n('street'), "</b>: ").concat(this.data_.txtStreet, "</span>") : '', "\n     ").concat(this.data_.locality ? "<span><b>".concat(i18n('city'), "</b>: ").concat(this.data_.locality, "</span>") : '', "\n     ").concat(this.data_.postalcode ? "<span><b>".concat(i18n('postalCode'), "</b>: ").concat(this.data_.postalcode, "</span>") : '', "\n     ").concat(this.data_.municipality ? "<span><b>".concat(i18n('municipality'), "</b>: ").concat(this.data_.municipality, "</span>") : '', "\n     ").concat(this.data_.subregion ? "<span><b>".concat(i18n('regionLevel2'), "</b>: ").concat(this.data_.subregion, "</span>") : '', "\n     ").concat(this.data_.region ? "<span><b>".concat(i18n('regionLevel1'), "</b>: ").concat(this.data_.region, "</span>") : '', "\n     <span><b>").concat(i18n('country'), "</b>: ").concat((_a = this.data_.country) !== null && _a !== void 0 ? _a : this.data_.txtCityPostalcode, "</span>\n     ").concat(this.data_.height ? "<span><b>".concat(i18n('altitude'), "</b>: ").concat(this.data_.height, "m</span>") : '', "\n     ").concat(this.data_.kmh ? "<span><b>".concat(i18n('maximumSpeed'), "</b>: ").concat(this.data_.kmh, " km/h</span>") : '', "\n     <span><b>").concat(i18n('xy'), "</b>: ").concat(this.data_.txtCoord, "</span>");
        this.jqElement_.find('.detailed .content').html(html);
    };
    /**
     * @return {import('../servers').GeEntity} ge GeEntity.
     */
    VAddress.prototype.getGeoEntity = function () {
        return this.ge_;
    };
    /**
     * @param {boolean} visible Visible
     */
    VAddress.prototype.toggleBtnSaveKml = function (visible) {
        var btn = this.jqElement_.find('button.save');
        if (visible) {
            btn.show();
        }
        else {
            btn.hide();
        }
    };
    /**
     * Click direction
     */
    VAddress.prototype.clickDirectionTo = function () {
        this.jqElement_.find('button.routing').click();
        this.hide();
        this.reset();
    };
    return VAddress;
}(BaseView));
export default VAddress;
//# sourceMappingURL=VAddress.js.map